<template>
  <Modal
    v-model="visible"
    :title="type == 1?'DLL注入管理':'开机通道管理'"
    :width="800"
    :mask-closable="false"
    >
      <Form :label-width="70">
        <FormItem label="网吧信息:">
          <b>{{curData.barName}}（{{curData.barId}}）</b>
        </FormItem>
      </Form>
      <Table :columns="columns" :data="data" :loading="loading">
        <template slot-scope="{row,index}" slot="fileType">
          <template v-if="row.fileType ==1">本地文件</template>
          <template v-else-if="row.fileType ==2">云端文件</template>
          <template v-else-if="row.fileType ==0">网络文件</template>
          <template v-else>脚本</template>
        </template>
        <template slot-scope="{row,index}" slot="fitOs">
          <!-- {{ $envFn(row.) }} -->
          <template v-for="item in row.fitOs">
            <Tag>{{$EnvFn.getOs(item)}}</Tag>
          </template>
        </template>
        <template slot-scope="{row,index}" slot="status">
          <i-switch v-model="row.status"  size="large" @on-change="onchangeOpen(row)">
            <span slot="open">开启</span>
                  <span slot="close">关闭</span>
          </i-switch>
        </template>
      </Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page :total="total" show-total :current="pageNo"
            @on-page-size-change="pageSizeChange" @on-change="changePage"></Page>
        </div>
    </div>
    </Modal>
</template>
<script>
import {findPage, switchBarStatus} from '@/requests/task'

export default {
  data() {
    return {
      visible: false,
      curData: '',
      type: 3,
      loading: false,
      columns: [
        // {
        //   type: 'selection',
        //   width: 30,
        //   align: 'center'
        // },
        {
          title: 'ID',
          key: 'id',
          width: 30,
          align: 'center'
        },
        {
          title: '任务名称',
          key: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '文件类型',
          slot: 'fileType', align: 'center'
        },
        {
          title: '文件值',
          key: 'filePath', align: 'center'
        },
        {
          title: '生效系统',
          slot: 'fitOs',
          ellipsis: true, align: 'right',
          width: 200
        },
        // {
        //   title: '任务说明',
        //   key: 'description',
        // },
        // {
        //   title: '版本号',
        //   key: 'version',
        // },
        {
          title: '更新时间',
          key: 'changeTime',
          align: 'center',
          width: 150
        },
        {
          title: '状态',
          slot: 'status',
          width: 60, align: 'center'
        },
      ],
      data: [],
      title: '',
      status: '',
      barId: '',
      pageSize: 10,
      pageNo: 1,
      total: 0
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.init()
      }
    }
  },
  // mounted() {
  //   this.init()
  // },
  methods: {
    async onchangeOpen(val) {
      let res = await switchBarStatus({
        'ids': [val.id],
        'status': Number(val.status), // 1:开启  0：停用
        'barId': this.curData.barId
      })
      if (res.code == 200) {
        if (val.status) {
          this.$Message.success('开启成功')
        } else {
          this.$Message.success('关闭成功')
        }
      } else {
        this.findPage()
        this.$Message.error(res.msg)
      }
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.findPage()
    },
    changePage(val) {
      this.pageNo = val
      this.findPage()
    },
    init() {
      this.pageNo = 1
      this.findPage()
    },
    async findPage() {
      this.loading = true
      let res = await findPage({
        title: this.title,
        status: this.status,
        barId: this.curData.barId,
        pageSize: 10,
        pageNo: 1,
        type: this.type
      })
      this.loading = false
      if (res.code == 200) {
        res.data.records.forEach(element => {
          element.fitOs = element.fitOs.split(',')
          element.status = Boolean(element.status)
        });
        this.data = res.data.records
        this.total = Number(res.data.total)
      }
    }
  }
}
</script>